<template>
    <button :type="type"
            class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-cyan-700 hover:text-cyan-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
        <slot></slot>
    </button>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
    props: {
        type: {
            type: String,
            default: 'button',
        },
    }
})
</script>
